// extracted by mini-css-extract-plugin
export var connectionButton = "_aj-1";
export var rightPanel = "_aj-3";
export var stepDescription = "_aj-2";
export var stepIcon = "_aj-0";